import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import styles from './AccessDenied.module.scss';

export function AccessDenied() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.iconWrapper}>
          <div className={styles.icon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
          </div>
        </div>

        <h1 className={styles.title}>Accès Refusé</h1>

        <p className={styles.message}>
          Désolé <span className={styles.gamertag}>{user?.gamertag || 'Joueur'}</span>,
          vous n'avez pas les permissions nécessaires pour accéder au panel staff.
        </p>

        <div className={styles.info}>
          <div className={styles.infoIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </div>
          <p>
            Si vous pensez qu'il s'agit d'une erreur, contactez un administrateur.
          </p>
        </div>

        <button className={styles.logoutButton} onClick={handleLogout}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Se déconnecter
        </button>
      </div>
    </div>
  );
}
